import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
  Input,
} from 'reactstrap'
import get from 'lodash/get'
import NumberFormat from 'react-number-format'
import styled from 'styled-components'

class AddVendorForm extends React.Component {
  render() {
    const open = get(this.props, 'open')
    const toggle = get(this.props, 'toggle')
    const handleInput = get(this.props, 'handleInput')
    // const vendor_name = get(this.props, 'vendor_name')
    // const vendor_sub_project_code = get(this.props, 'vendor_sub_project_code')
    // const vendor_description = get(this.props, 'vendor_description')
    const vendor_cost = get(this.props, 'vendor_cost')
    const vendor_price = get(this.props, 'vendor_price')
    const vendor_man_days = get(this.props, 'vendor_man_days')
    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <HeaderForm toggle={ () => toggle() }>
          <HeadLabel>Add Other Service</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container >
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Sub-Project Code</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <InputField
                          name="vendor_sub_project_code"
                          onBlur={ (e) => handleInput(e) }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Other Service Name</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <InputField
                          name="vendor_name"
                          onBlur={ (e) => handleInput(e) }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Description</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <InputField
                          name="vendor_description"
                          onBlur={ (e) => handleInput(e) }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Total Cost (฿)</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <NumberFieldSub
                          name="vendor_cost"
                          value={ vendor_cost }
                          thousandSeparator={ true }
                          decimalScale={ 2 }
                          fixedDecimalScale={ true }
                          onBlur={ (e) => {
                            e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                            handleInput(e)
                          } }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Sale Price (฿)</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <NumberFieldSub
                          name="vendor_price"
                          value={ vendor_price }
                          allowEmptyFormatting={ true }
                          thousandSeparator={ true }
                          decimalScale={ 2 }
                          fixedDecimalScale={ true }
                          onBlur={ (e) => {
                            e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                            handleInput(e)
                          } }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Man-Day(s)</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <NumberFieldSub
                          name="vendor_man_days"
                          value={ vendor_man_days }
                          allowEmptyFormatting={ true }
                          thousandSeparator={ true }
                          decimalScale={ 2 }
                          fixedDecimalScale={ true }
                          onBlur={ (e) => {
                            e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                            handleInput(e)
                          } }
                        />
                      </Col>
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          { get(this.props, 'button') }
        </ModalFooter>
      </Modal>
    )
  }
}

export default AddVendorForm

const InputField = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const HeaderForm = styled(ModalHeader)`
    font-family: 'Gotham-Bold' !important;
    font-size: 12px ;
`
const HeadLabel = styled(Label)`
    font-family: 'Gotham-Bold' !important;
    font-size: 16px ;
    color: #AD2624;
    margin-left: 5px;
`
const TextLabel = styled(Label)`
    font-family: 'Gotham-Bold' !important;
    font-size: 14px ;
    margin-left: 5px;
`
const NumberFieldSub = styled(NumberFormat)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height: 100%;
    font-size: 12px ;
    border-radius: 5px;
    border: ${props => {
    if (props.invalid) {
      return '1px solid red'
    }
    return '1px solid #CCCCCC'
  }};
    background-color: ${props => {
    const status = props.disabled
    if (status === !get(this.props, 'edit_resource')) {
      return '#E8ECEF'
    }
    return '#FFFFFF'
  }};
`




// WEBPACK FOOTER //
// ./src/components/project-information/form/add-vendor/index.js